import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import HistoryIcon from "@mui/icons-material/History";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HttpsIcon from "@mui/icons-material/Https";
import { Link } from "react-router-dom";
import FeedIcon from "@mui/icons-material/Feed";
import { Typography } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import Avatar from "@mui/material/Avatar";
import { Badge } from "@mui/material";
import { useAuth } from "../../context/AuthContext";

const useStyles = makeStyles({
  title: {
    fontWeight: "bold",
    paddingLeft: "40px",
    fontSize: "18px",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  leftmenu: {
    border: "1px solid lightgray",
    borderRadius: "5px",
    lineHeight: "2.5em",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  each: {
    display: "flex",
    alignItems: "center",
    paddingLeft: "33px",
  },
  each_cursor: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    paddingLeft: "33px",
    borderRight: "10px solid #78909c",
  },
});

const DashboardMenu = ({ page }) => {
  const { getFirstname } = useAuth();
  const classes = useStyles();

  // console.log(localStorage.getItem("firstname"));
  // useEffect(() => {
  // 	if (getFirstname().length === 0) {
  // 		setFirstname((old) => localStorage.getItem("firstname"));
  // 	} else {
  // 		setFirstname(getFirstname());
  // 	}
  // 	if (getLastname().length === 0) {
  // 		setFirstname((old) => localStorage.getItem("firstname"));
  // 	} else {
  // 		setLastname(getLastname());
  // 	}
  // }, []);

  return (
    <>
      <Box className={classes.leftmenu}>
        <Box className={classes.title}>
          <Badge
            color="secondary"
            overlap="circular"
            variant="dot"
            sx={{ position: "relative", left: "-20px" }}
          >
            <Avatar
              sx={{
                width: "30px",
                height: "30px",
                mr: 2,
                position: "relative",
                left: "+13px",
              }}
            ></Avatar>
          </Badge>
          Welcome, {getFirstname()}
        </Box>
        <Box></Box>
        {page === "profile" ? (
          <Box className={classes.each_cursor}>
            <AccountCircleIcon />
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/dashboard">Dashboard</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <AccountCircleIcon />
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/dashboard">Dashboard</Link>
            </Box>
          </Box>
        )}
        {page === "order-history" ? (
          <Box className={classes.each_cursor}>
            <HistoryIcon />
            <Box
              sx={{
                pt: 1,
                pl: 1,
              }}
            >
              <Link to="/order-history">Your orders</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <HistoryIcon />
            <Box
              sx={{
                pt: 1,
                pl: 1,
              }}
            >
              <Link to="/order-history">Your orders</Link>
            </Box>
          </Box>
        )}
        {page === "userinfo" ? (
          <Box className={classes.each_cursor}>
            <FeedIcon />
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/change-userinfo">Personal information</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <FeedIcon />
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/change-userinfo">Personal information</Link>
            </Box>
          </Box>
        )}
        {page === "password" ? (
          <Box className={classes.each_cursor}>
            <HttpsIcon />
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/change-password">Change Password</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <HttpsIcon />
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/change-password">Change Password</Link>
            </Box>
          </Box>
        )}
        {page === "communication" ? (
          <Box className={classes.each_cursor}>
            <HttpsIcon />
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/communication">Communication</Link>
            </Box>
          </Box>
        ) : (
          <Box className={classes.each}>
            <HttpsIcon />
            <Box sx={{ pt: 1, pl: 1 }}>
              <Link to="/communication">Communication</Link>
            </Box>
          </Box>
        )}
      </Box>
      <Box
        className={classes.leftmenu}
        sx={{ mt: 4, px: 3, lineHeight: "1.8em", color: "#9e9e9e", pb: 3 }}
      >
        <Box sx={{ position: "relative", top: "+20px" }}>
          <AdminPanelSettingsIcon sx={{ color: "#36b4e6" }} />
        </Box>
        <Typography sx={{ pt: 2, pb: 2 }}>Your Privacy</Typography>
        We collect information from you when you register on the site, place an
        order. When ordering or registering, we ask for your name, e-mail
        address, mailing address, phone number, and credit card information. We
        never sell your information.
      </Box>
    </>
  );
};

export default DashboardMenu;
